import { render } from "./printFaceOrder.vue?vue&type=template&id=b9a373ea&scoped=true"
import script from "./printFaceOrder.vue?vue&type=script&lang=js"
export * from "./printFaceOrder.vue?vue&type=script&lang=js"

import "./printFaceOrder.vue?vue&type=style&index=0&id=b9a373ea&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b9a373ea"

export default script